var map = {
	"./canvas-day-cool.jpg": "2df0",
	"./canvas-day-normal.jpg": "603c",
	"./canvas-day-warm.jpg": "c3fe",
	"./canvas-evening-cool.jpg": "c723",
	"./canvas-evening-normal.jpg": "66b1",
	"./canvas-evening-warm.jpg": "f32f",
	"./canvas-morning-cool.jpg": "0fee",
	"./canvas-morning-normal.jpg": "685b",
	"./canvas-morning-warm.jpg": "b4c6",
	"./canvas-night-cool.jpg": "bebb",
	"./canvas-night-normal.jpg": "862d",
	"./canvas-night-warm.jpg": "c2bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3ab2";